import { getBaseUrl } from '../../maps/apiEnvironmentMap';

const API_KEY = process.env.REACT_APP_API_KEY;
export class EmployeeLoginRequestPOST {
  readonly method: string = 'auth/employee/login';
  public buildURL() {
    let baseURL = getBaseUrl('locker');
    return `${baseURL}/${this.method}`;
  }

  public generateContent(employeeNumber: string, password?: string) {
    const params: EmployeeLoginPayload = {
      employeeNumber: employeeNumber,
    };
    if (password) {
      params.password = password;
    }
    return params;
  }
  public generateConfig(token: string) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'dhl-api-key': API_KEY,
        'Content-Type': 'application/json',
      },
    };
  }
}

type EmployeeLoginPayload = {
  employeeNumber: string;
  password?: string;
};
export type EmployeeLoginResponsePOST = {
  status: string;
  message: string;
  data: {
    message: string;
    errors: any;
    token: string;
    tokenType: string;
    expiresIn: number;
  };
};
